import { createStore } from 'vuex'
import getters from './getters';
import tagsView from './modules/tagsView';
import zdy from './modules/zdy'
import params from './modules/params';

const store = createStore({
    modules: {
        tagsView,
        zdy,
        params,
    },
    getters,
});

export default store;